import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwArticle = (props) => {
  const classes = useStyles();
  const [classnames, setClassnames] = useState('');

  useEffect(() => {
      // if(props.data && props.data.class){
      //     setClassnames(props.data.class);
      // }
  },[props.data])

  return (
    <>
      {props.data && props.data.source && (
        <Grid container>
          <Grid item xs={12}>
            <Typography className={classes.articlecss}>
              <div
                className={classnames}
                id={props.data.myId.self}
                dangerouslySetInnerHTML={{
                  __html: unicodeToString(props.data.source),
                }}
                style={{display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block'}}
              ></div>
            </Typography>
          </Grid>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  articlecss: {
    lineHeight: 1.3,
    fontSize: "140%",
    padding: "5px 15px",
    width: "98%",
    backgroundColor: "rgba(255, 255, 255, 0.5)",
    borderRadius: "5px",
    borderBottom: "1px solid rgb(239, 239, 239)",
    margin: "5px",
  },
});
export default WwArticle;
